// libs
import React from 'react';

import { cn } from '@lyearn/style';
import CellBackdrop from '@/modules/corporate/modules/database/fields/components/CellBackdrop';
// components
import DatabaseSelect from '@/modules/corporate/modules/database/fields/components/DatabaseSelect';
// hooks
import useSelectEditableCell from '@/modules/corporate/modules/database/fields/hooks/useSelectEditableCell';
// styles
import {
  getClasses,
  rectPositionStyles,
} from '@/modules/corporate/modules/database/fields/select/styles';
// types
import { CellProps } from '@/modules/corporate/modules/database/types';

function MultiSelectEditableCell(props: CellProps) {
  const { toggleIsEditing, column, cellData, rowData, onAction } = props;
  const selectProps = useSelectEditableCell({
    documentId: rowData._id,
    fieldId: column.id,
    multiple: true,
    onAction,
    toggleIsEditing,
  });

  return (
    <CellBackdrop onClickAway={toggleIsEditing}>
      {(rect) => (
        <DatabaseSelect
          className={cn('fixed', rectPositionStyles(rect))}
          classes={getClasses(rect.height)}
          field={column.field}
          value={cellData?.value}
          {...selectProps}
        />
      )}
    </CellBackdrop>
  );
}

export default MultiSelectEditableCell;
